// creates a function to only run after a set amount of time, `ms` is the unique string to each function
var waitForFinalEvent = (function () {
  var timers = {};
  return function (callback, ms, uniqueId) {
    if (!uniqueId) {
      uniqueId = "Don't call this twice without a uniqueId";
    }
    if (timers[uniqueId]) {
      clearTimeout (timers[uniqueId]);
    }
    timers[uniqueId] = setTimeout(callback, ms);
  };
})();

var bottomMenu = $('.bottom-menu');
if ( bottomMenu.length ) {


    setTimeout(function(){

        if ( $('.fig-banner').length ) {

            var bannerHeight = $('.fig-banner').outerHeight(true);
            bottomMenu.scrollToFixed({
                bottom: bannerHeight,
                limit: function(){
                    return $('footer').offset().top;
                }
            });
            $(window).resize(function() {
                var bannerHeight = $('.fig-banner').outerHeight(true);
                $('.bottom-menu.scroll-to-fixed-fixed').css({"bottom": bannerHeight + "px"});
            });
            } else {
                bottomMenu.scrollToFixed({
                    bottom: 0,
                    limit: function(){
                        return $('footer').offset().top;
                    }
                });
            }
    }, 1);

    var bottomMenuItem = $('.fig-tab-open'),
        bottomMenuTabContainer = $('.tab-container'),
        bottomMenuContainer = $('.bottom-item-container'),
        navigationTab = $('.open-navigation'),
        navigationIcon = $('.icon'),
        bottomMenu = $('.bottom-menu');

    $(window).resize(function () {
        waitForFinalEvent(function(){
            bottomMenu.find(bottomMenuContainer).removeClass('active');
        }, 300, "bottom-menu");
    });

    navigationTab.on('keypress click', function(e) {
        if (e.which === 13 || e.type === 'click') {
            if ( $(this).closest(bottomMenuContainer).hasClass('active') ) {
                $(this).find(navigationIcon).removeClass('icon-arrow-down');
                $(this).find(navigationIcon).addClass('icon-arrow-right');
            } else {
                $(this).find(navigationIcon).removeClass('icon-arrow-right');
                $(this).find(navigationIcon).addClass('icon-arrow-down');
            }
        }
    });

    bottomMenuItem.on('keypress click', function(e) {
        if (e.which === 13 || e.type === 'click') {
            if ( $(this).closest(bottomMenuContainer).hasClass('active') ) {
                $(this).closest(bottomMenuContainer).removeClass('active');
                e.preventDefault();
            } else {
                $(this).closest(bottomMenu).find(bottomMenuContainer).removeClass('active');
                var currentThis = $(this);
                window.setTimeout(function(){
                    currentThis.closest(bottomMenuContainer).addClass('active');
                }, 400);
                e.preventDefault();
            }
        }
    });
}



// WEBPACK FOOTER //
// ./wp-content/themes/figpress-child/src/js/modules/_FooterMenu.js